import TeamMemberPasswordResetView from './TeamMemberPasswordResetView';
export default TeamMemberPasswordResetView;
